import { useMutation } from "@tanstack/react-query";
import {
  getApiUrl,
  postInvoicesLicenseLicensePublicIDRegeneratePath,
} from "Infrastructure/Api/Api";
import { JWT_KEY } from "Utils/AuthUtils";
import { getLocalStorageItem } from "Utils/Storage/LocalStorage/SecureLocalStorage";
import FileSaver from "file-saver";
import { toast } from "sonner";
import { Resources, useResource } from "Translations/Resources";

const CONTROLS_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.Licenses.Form.Controls;

type Params = {
  licensePublicID: string;
};

const regenerateLicenseInvoice = async ({ licensePublicID }: Params) => {
  const route = `${getApiUrl()}${postInvoicesLicenseLicensePublicIDRegeneratePath(licensePublicID)}`;
  const response = await fetch(route, {
    method: "POST",
    mode: "cors",
    headers: { Authorization: getLocalStorageItem(JWT_KEY) ?? "" },
  });

  return response;
};

export const useRegenerateLicenseInvoiceMutation = () => {
  const { t } = useResource();

  return useMutation({
    mutationFn: async (params: Params) => {
      const response = await regenerateLicenseInvoice(params);
      if (!response.ok) {
        throw new Error(t(CONTROLS_RESOURCES.RegenerateInvoiceError));
      }
      const blob = await response.blob();
      FileSaver.saveAs(blob, `faktura_${params.licensePublicID}.pdf`);
    },
    onSuccess: () => {
      toast.success(t(CONTROLS_RESOURCES.RegenerateInvoiceSuccess));
    },
    onError: () => {
      toast.error(t(CONTROLS_RESOURCES.RegenerateInvoiceError));
    },
  });
};
